module.exports = __webpack_public_path__ + "static/media/cup-jour4.4d8ef5bb.svg";